import { render, staticRenderFns } from "./PartnersCard.vue?vue&type=template&id=26507ea9"
import script from "./PartnersCard.vue?vue&type=script&lang=js"
export * from "./PartnersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports